import { render, staticRenderFns } from "./DeliveryNotificationsView.vue?vue&type=template&id=2ce63bfc&scoped=true&"
import script from "./DeliveryNotificationsView.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNotificationsView.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNotificationsView.vue?vue&type=style&index=0&id=2ce63bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce63bfc",
  null
  
)

component.options.__file = "DeliveryNotificationsView.vue"
export default component.exports